<div class="layout">
  <!-- 
    =(x)= ToolCade 👾 =====================
    [i]===------------------------------
    [i]===------------------------------
    [i]===------------------------------
    [i]===------------------------------
  -->
  <mat-toolbar class="layout-header" *ngIf="(isSidenavVisible$ | async) === false">
    <ng-container [ngTemplateOutlet]="headerContent()?.tpl || noHeaderContent"></ng-container>
    <ng-template #noHeaderContent>
      <header>Please provide a header content</header>
    </ng-template>
  </mat-toolbar>

  <mat-sidenav-container class="layout-navigation"
    [ngClass]="{ 'opened': (sideNavOpen$ | async), 'closed': (sideNavOpen$ | async) === false }"
    [hasBackdrop]="(isMobile$ | async)" autosize="true">

    <!-- Left Sidenav (Optional Properties/Menu) -->
    @if (sidenavService.leftOpen()) {
    <mat-sidenav mode="side" [opened]="sidenavService.leftOpen()" [disableClose]="true" position="start"
      class="shared-left-sidenav">
      <ng-container *ngIf="sidenavService.leftOpen()" [ngTemplateOutlet]="sidenavService.leftContent()"></ng-container>
    </mat-sidenav>
    }

    <!-- Right Sidenav (Tool Options/Context Actions) -->
    @if (sidenavService.rightOpen()) {
    <mat-sidenav [mode]="(isMobile$ | async) ? 'over' : 'side'" [opened]="sidenavService.rightOpen()"
      [disableClose]="(isMobile$ | async) === false" position="end" class="shared-right-sidenav">


      <ng-container *ngIf="sidenavService.rightOpen()"
        [ngTemplateOutlet]="sidenavService.rightContent()"></ng-container>
    </mat-sidenav>
    }


    <!-- Bottom Sidenav (Mobile Actions/Quick Access) -->
    @if (sidenavService.bottomOpen()) {
    <mat-sidenav mode="over" [opened]="sidenavService.bottomOpen()" [disableClose]="true" position="end"
      class="shared-bottom-sidenav">
      <ng-container *ngIf="sidenavService.bottomOpen()"
        [ngTemplateOutlet]="sidenavService.bottomContent()"></ng-container>
    </mat-sidenav>
    }

    <!-- Navigation Sidenav (Mobile Menu - preserves default backdrop/close behavior) -->
    @if ((isSidenavVisible$ | async)) {
    <mat-sidenav [opened]="(isSidenavVisible$ | async)" mode="over" from="bottom" class="mobile-nav-sidenav"
      (closedStart)="themeService.closeSideNav()">
      <ng-container [ngTemplateOutlet]="navigationContent()?.tpl || noNavigationContent"></ng-container>
      <ng-template #noNavigationContent>Please provide a navigation content</ng-template>
    </mat-sidenav>
    }

    <mat-sidenav-content #contentArea>
      <div class="main-content-wrapper" [ngClass]="{ 'has-mobile-actions': sidenavService.mobileActionsVisible() }">

        <ng-container [ngTemplateOutlet]="content()?.tpl || noContent"></ng-container>
        <ng-template #noContent>Please provide main content</ng-template>
      </div>

      <!-- Footer moved inside to prevent outer page scrollbar -->
      <div class="w-full bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800">
        <ng-container [ngTemplateOutlet]="footerContent()?.tpl || noFooterContent"></ng-container>
        <ng-template #noFooterContent>
          <footer class="p-4 text-center">No footer Content</footer>
        </ng-template>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>